import React from "react";

export interface AssistantOverviewProps {
	workspaceId: string;
	session?: any;
	currentWorkspace?: any;
}

export const AssistantOverview: React.FC<AssistantOverviewProps> = ({
	workspaceId,
	session,
	currentWorkspace,
}) => {
	return (
		<div className="flex h-full flex-col items-center justify-center bg-background p-8 text-foreground">
			<h1 className="mb-2 font-bold text-2xl">AI Assistant</h1>
			<p className="text-muted-foreground">
				Workspace: <span className="font-mono">{workspaceId}</span>
			</p>
			<p className="mt-4 text-muted-foreground text-sm">
				AI Assistant interface would go here
			</p>
		</div>
	);
};